import { _WarnImport } from "../Misc/devTools.js";
/** @hidden */
export var _injectLTSMesh = function (Mesh) {
    Mesh.prototype.setMaterialByID = function (id) {
        return this.setMaterialById(id);
    };
    Mesh.CreateDisc = Mesh.CreateDisc || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateBox = Mesh.CreateBox || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateSphere = Mesh.CreateSphere || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateCylinder = Mesh.CreateCylinder || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateTorusKnot = Mesh.CreateTorusKnot || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateTorus = Mesh.CreateTorus || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreatePlane = Mesh.CreatePlane || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateGround = Mesh.CreateGround || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateTiledGround = Mesh.CreateTiledGround || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateGroundFromHeightMap = Mesh.CreateGroundFromHeightMap || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateTube = Mesh.CreateTube || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreatePolyhedron = Mesh.CreatePolyhedron || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateIcoSphere = Mesh.CreateIcoSphere || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateDecal = Mesh.CreateDecal || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateCapsule = Mesh.CreateCapsule || (function () { throw _WarnImport("MeshBuilder"); });
    Mesh.CreateGoldberg = Mesh.CreateGoldberg || (function () { throw _WarnImport("MeshBuilder"); });
};
//# sourceMappingURL=mesh.lts.js.map